import Vue from "vue";
import VueMoent from "vue-moment";
import VueCookies from "vue-cookies";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import i18n from "@/locales/i18n.js";
import Loading from "@/plugin/loading.js";
import Alert from "@/plugin/alert.js";
import ClickOutsideDrective from "@/plugin/click-outside-drective.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(VueMoent);
Vue.use(VueAwesomeSwiper);
Vue.use(Loading);
Vue.use(Alert);
Vue.use(ClickOutsideDrective);

axios.interceptors.response.use((res) => {
  if (res.data.code === 3000) {
    const message = res.data.message.split("<br>");
    const query = `?detail=${message[0].trim()}&period=${message[1].trim()}`;
    window.location.href = `/maintenance${query}`;
  } else {
    return res;
  }
});

const vue = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
window.app = vue;
